"use strict";

// Special types that need to be handled differently from classic inputs
module.exports = {
    REACT_DATEPICKER: "react-datepicker",
    CHECKBOX: "checkbox",
    TEXTAREA: "textarea"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-validation/lib/js/ValidationTypes.js
// module id = 701
// module chunks = 93